import { useEffect, useState } from "react";
import { SectionService } from "../services";

type SectionsDataReturn<T> = {
  data: T;
  isLoading: boolean;
};

const useSectionsData = <T = any>(moduleType: string, sectionsSlug: string) => {
  const [sectionsData, setSectionsData] = useState<T | undefined>(undefined);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const getSectionsData = async () => {
      try {
        setIsLoading(true);
        const response = await SectionService.getDynamicSections({
          moduleType,
          slug: sectionsSlug
        });
        setSectionsData(response[0]);
      } catch (error) {
        console.error("Sections data fetch got error:", error);
        setSectionsData(undefined);
      } finally {
        setIsLoading(false);
      }
    };
    getSectionsData();
  }, [moduleType, sectionsSlug]);

  return { data: sectionsData, isLoading } as SectionsDataReturn<T>;
};

export default useSectionsData;
